const $ = require('jquery');
const { copyToClipboard } = require('core/src/utils/clipboard');

const initClipboardUI = () => {
    // Event delegation for dynamically added elements
    $('body').on('click', '.copy-to-clipboard', function(e) {
        // If the click is on a link inside, we might want to let it bubble?
        // User request: "o etikete tıklandığında kopyalasan"
        // But if it's a link, we probably don't want to follow it AND copy. 
        // Assuming we prioritize copying or the element is not a functional link.
        // e.preventDefault(); 
        
        const $element = $(this);
        // Get text from data-clipboard-text attribute if present, otherwise element text
        const text = $element.attr('data-clipboard-text') || $element.text();
        
        copyToClipboard(text);
        
        // Visual feedback via class
        $element.addClass('copied');
        setTimeout(() => {
            $element.removeClass('copied');
        }, 1500);
    });
};

module.exports = initClipboardUI;